/**
 * 実績一覧ページ
 */
import React from 'react';
import styles from './Works.module.css';
import headerBg from '../../assets/images/武蔵野大学.jpg';

// ★ さっき作った「カード職人」を読み込む！
import WorksComponents from '../../components/Works/WorksComponents';

function Works() {
  return (
    <div className={styles.container}>
      {/* 1. タイトル付きヘッダー */}
      <header className={styles.homeHeader}>
        <img 
          src={headerBg} 
          alt="Works" 
          className={styles.headerImage} 
        />
        <div className={styles.headerOverlay}>
          <h1 className={styles.headerTitle}>Works</h1>
        </div>
      </header>

      {/* 2. メインコンテンツ */}
      <main className={styles.mainContent}>
        
        {/* ★ ここにAPI通信とカードデザインが詰まった部品をドーン！と配置する */}
        <WorksComponents />
        
      </main>
    </div>
  );
}

export default Works;